import {
  Text,
  Box,
  Flex,
  Spacer,
  AspectRatio,
  Heading,
  Image,
  HStack,
  Icon,
} from '@chakra-ui/react';

import Content from '~/containers/Content';

import { IoChevronForward } from 'react-icons/io5';

import defaultImage from '~/assets/images/defaultImage.png';

type StoreInfoBarProps = {
  logo: string;
  name: string;
  onNavigate?: () => void;
};

export default function StoreInfoBar({ logo, name, onNavigate }: StoreInfoBarProps) {
  return (
    <Box bgColor="white" px={4}>
      <Content>
        <Flex h={10}>
          <HStack>
            <AspectRatio w="35px" ratio={1}>
              <Image src={logo || defaultImage} />
            </AspectRatio>
            <Heading size="sm">{name}</Heading>
          </HStack>

          <Spacer />

          {onNavigate ? (
            <HStack as="a" spacing={0} align="center" onClick={onNavigate} cursor="pointer">
              <Text fontSize="sm" color="gray.500">
                餐廳介紹
              </Text>
              <Icon as={IoChevronForward} color="gray.500" />
            </HStack>
          ) : (
            <Box />
          )}
        </Flex>
      </Content>
    </Box>
  );
}
